<template>
    <div class="contents">
        <i class="icon-chevron-down"></i>
        <ul class="cart-items">
            <li v-for="item in items" :key="item.id">
                <i class="icon-close float-right" @click="removeItem({id: item.id, row: item.rowId})"></i>
                <a :href="item.detail" :title="item.name">
                  {{ item.name }}
                </a>
                <div class="row">
                    <div class="col align-self-end">
                        <a :href="item.detail" :title="item.name">
                          <img class="cart-dropdown-image" :src="item.thumb" :alt="item.name" />
                        </a>
                    </div>
                    <div class="col align-self-end">{{ formatQuantity(item) }} x {{ item.unit }}</div>
                    <div class="col align-self-end">
                      <template v-if="item.is_discounted">
                        <span class="text-line-through">{{ item.brutto_price | money }}/{{ item.unit }}</span>
                        <br>
                      </template>
                      {{ item.price | money }}/{{ item.unit }}
                      </div>
                </div>
            </li>
            <li class="total">{{ $t('cart.total') }}: <span class="float-right">{{ brutto_discounted | money }}</span></li>
        </ul>
        <a :href="`/${$t('routes.cart')}`" class="btn btn-outline-green">{{ $t('cart.view-cart') }}</a>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('cart')

export default {

  computed: {

    ...mapState(['items']),
    ...mapGetters(['brutto_discounted'])

  },

  methods: {

    ...mapActions(['removeItem']),

    formatQuantity (item) {
      return item.unit === 'm' ? parseFloat(item.qty).toFixed(2).replace('.', ',') : parseInt(item.qty)
    }

  },

  filters: {
    money (value) {
      return parseFloat(value).toLocaleString('sl-SI', { style: 'currency', currency: 'EUR' })
    }
  }

}
</script>
